/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { RoleMapping } from '../models/role-mapping';
import { CustomRoleRequest } from '../models/custom-role-request';

/**
 * Ui Custom Role Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiCustomRoleControllerService extends __BaseService {
  static readonly getAllCustomRolesUsingGETPath = '/cc-ui/v1/custom-role';
  static readonly createCustomRoleUsingPOSTPath = '/cc-ui/v1/custom-role';
  static readonly getAllRolesUsingGETPath = '/cc-ui/v1/custom-role/roles';
  static readonly getCustomRoleUsingGETPath =
    '/cc-ui/v1/custom-role/{roleName}';
  static readonly updateCustomRoleUsingPUTPath =
    '/cc-ui/v1/custom-role/{roleName}';
  static readonly deleteCustomRoleUsingDELETEPath =
    '/cc-ui/v1/custom-role/{roleName}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllCustomRoles
   * @return OK
   */
  getAllCustomRolesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<RoleMapping>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/custom-role`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RoleMapping>>;
      }),
    );
  }
  /**
   * getAllCustomRoles
   * @return OK
   */
  getAllCustomRolesUsingGET(): __Observable<Array<RoleMapping>> {
    return this.getAllCustomRolesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<RoleMapping>),
    );
  }

  /**
   * createCustomRole
   * @param request request
   * @return OK
   */
  createCustomRoleUsingPOSTResponse(
    request: CustomRoleRequest,
  ): __Observable<__StrictHttpResponse<RoleMapping>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/custom-role`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RoleMapping>;
      }),
    );
  }
  /**
   * createCustomRole
   * @param request request
   * @return OK
   */
  createCustomRoleUsingPOST(
    request: CustomRoleRequest,
  ): __Observable<RoleMapping> {
    return this.createCustomRoleUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as RoleMapping),
    );
  }

  /**
   * getAllRoles
   * @return OK
   */
  getAllRolesUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<RoleMapping>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/custom-role/roles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RoleMapping>>;
      }),
    );
  }
  /**
   * getAllRoles
   * @return OK
   */
  getAllRolesUsingGET(): __Observable<Array<RoleMapping>> {
    return this.getAllRolesUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<RoleMapping>),
    );
  }

  /**
   * getCustomRole
   * @param roleName roleName
   * @return OK
   */
  getCustomRoleUsingGETResponse(
    roleName: string,
  ): __Observable<__StrictHttpResponse<RoleMapping>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/custom-role/${encodeURIComponent(String(roleName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RoleMapping>;
      }),
    );
  }
  /**
   * getCustomRole
   * @param roleName roleName
   * @return OK
   */
  getCustomRoleUsingGET(roleName: string): __Observable<RoleMapping> {
    return this.getCustomRoleUsingGETResponse(roleName).pipe(
      __map((_r) => _r.body as RoleMapping),
    );
  }

  /**
   * updateCustomRole
   * @param params The `UiCustomRoleControllerService.UpdateCustomRoleUsingPUTParams` containing the following parameters:
   *
   * - `roleName`: roleName
   *
   * - `request`: request
   *
   * @return OK
   */
  updateCustomRoleUsingPUTResponse(
    params: UiCustomRoleControllerService.UpdateCustomRoleUsingPUTParams,
  ): __Observable<__StrictHttpResponse<RoleMapping>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/custom-role/${encodeURIComponent(String(params.roleName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RoleMapping>;
      }),
    );
  }
  /**
   * updateCustomRole
   * @param params The `UiCustomRoleControllerService.UpdateCustomRoleUsingPUTParams` containing the following parameters:
   *
   * - `roleName`: roleName
   *
   * - `request`: request
   *
   * @return OK
   */
  updateCustomRoleUsingPUT(
    params: UiCustomRoleControllerService.UpdateCustomRoleUsingPUTParams,
  ): __Observable<RoleMapping> {
    return this.updateCustomRoleUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as RoleMapping),
    );
  }

  /**
   * deleteCustomRole
   * @param roleName roleName
   */
  deleteCustomRoleUsingDELETEResponse(
    roleName: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/custom-role/${encodeURIComponent(String(roleName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteCustomRole
   * @param roleName roleName
   */
  deleteCustomRoleUsingDELETE(roleName: string): __Observable<null> {
    return this.deleteCustomRoleUsingDELETEResponse(roleName).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiCustomRoleControllerService {
  /**
   * Parameters for updateCustomRoleUsingPUT
   */
  export interface UpdateCustomRoleUsingPUTParams {
    /**
     * roleName
     */
    roleName: string;

    /**
     * request
     */
    request: CustomRoleRequest;
  }
}

export { UiCustomRoleControllerService };
